'use client';

import React from 'react';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { SectionHeader, styles } from '../../product-landing/ProductLanding';

type PrivacyItem = { label: string; description: string };

export default function PrivacySection() {
  const { t } = useTranslation('start');
  const raw = t('mcp.privacy.items', { returnObjects: true });
  const items = (Array.isArray(raw) ? raw : []) as PrivacyItem[];
  return (
    <section className={`${styles.section} ${styles.band}`}>
      <div className={styles.split}>
        <div>
          <SectionHeader title={t('mcp.privacy.title')} intro={t('mcp.privacy.intro')} left />
          <p className={styles.note}>
            {t('mcp.privacy.policyNote')}{' '}
            <Link href="/polityka" className={styles.textLink}>{t('mcp.privacy.policyLinkLabel')}</Link>.
          </p>
        </div>
        <div className={styles.prose}>
          {items.map((item) => (
            <div key={item.label} className={styles.privacyItem}>
              <h3>{item.label}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
